import React from "react";
import { useHistory, Link } from "react-router-dom";
import logo from "../assets/images/header-logo.png";

const NewHeader = (props) => {
  const history = useHistory();
  return (
    <div>
      <nav
        className="navbar navbar-expand-lg shadow-lg"
        style={{ backgroundColor: "#FFF" }}
      >
        <div
          className="container-fluid mx-4 p-0 d-flex gap-1"
          style={{ justifyContent: "flex-start" }}
        >
          <Link className="navbar-brand" to="/dashboard">
            <img src={logo} alt="" width={75} />
          </Link>
          <div>
            <Link to="/dashboard">
              <h3 className="mb-1" style={{ color: "#000", fontSize: "20px" }}>
                Department of Power
              </h3>
              <p className="mb-1 fs-14 fw-600" style={{color: "#000"}}>Government of Nagaland</p>
            </Link>
          </div>
          {/* <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarTogglerDemo02"
            aria-controls="navbarTogglerDemo02"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button> */}
          <div className="collapse navbar-collapse" id="navbarTogglerDemo02">
            <ul
              className="navbar-nav mb-2 mb-lg-0"
              style={{ marginLeft: "auto" }}
            >
              {/* <li className="nav-item">
                <a
                  className="nav-link active fs-16"
                  aria-current="page"
                  href="/dashboard"
                >
                  Home
                </a>
              </li> */}
              {/* <li className="nav-item">
                <a className="nav-link" href="#">
                  Link
                </a>
              </li> */}
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default NewHeader;
